import { __makeTemplateObject } from "tslib";
import React, { useCallback } from 'react';
import Button from '@kvika/button';
import styled, { css } from 'styled-components';
import { Colors } from '@kvika/theme';
import { StyledTabContainer } from '../styles/LoginStyles';
var StyledTabButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: rgba(196, 196, 196, 0.2);\n  color: ", ";\n  font-weight: normal;\n  width: 100%;\n  :hover {\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  background-color: rgba(196, 196, 196, 0.2);\n  color: ", ";\n  font-weight: normal;\n  width: 100%;\n  :hover {\n    color: ", ";\n  }\n\n  ", "\n"])), Colors.gray900, Colors.black, function (props) {
    return props.isActive && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: rgba(196, 196, 196, 0.6);\n      border: 1px solid ", ";\n      color: ", ";\n      font-weight: bold;\n    "], ["\n      background-color: rgba(196, 196, 196, 0.6);\n      border: 1px solid ", ";\n      color: ", ";\n      font-weight: bold;\n    "])), Colors.gold550, Colors.black);
});
var Tab = function (_a) {
    var title = _a.title, setSelectedTab = _a.setSelectedTab, index = _a.index, isActive = _a.isActive, onClick = _a.onClick, testId = _a.testId;
    var onSetSelectedTab = useCallback(function () {
        setSelectedTab(index);
    }, [setSelectedTab, index]);
    return (React.createElement(StyledTabContainer, null,
        React.createElement(StyledTabButton, { isActive: isActive, onClick: function () {
                onSetSelectedTab();
                if (onClick) {
                    onClick();
                }
            }, testId: "".concat(testId, "-").concat(index) }, title)));
};
export default Tab;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Tab.js.map